import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-accordion-item/jb-accordion-item.scss?inline
var jb_accordion_item_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.item-title {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

.item-toggle:checked ~ .item-header .item-title::before {
  transform: rotate(90deg) !important;
}
.item-toggle:checked ~ .item-content {
  max-height: 5000px;
  padding-bottom: 30px;
  padding-top: 30px;
  transition-duration: 1s;
  transition-property: max-height;
}

.item {
  position: relative;
}

.item-header {
  border-bottom: 1px solid rgba(20, 30, 85, 0.3);
}

.item-title {
  color: #141e55;
  cursor: pointer;
  display: block;
  font-size: var(--theme-typo-p-highlight-desktop-fontsize, 1.188rem);
  line-height: var(--theme-typo-p-highlight-desktop-lineheight, 2.125rem);
  padding-block: var(--spacing-2xs);
  padding-inline: 0 calc(16px + var(--spacing-xs));
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.item-title::after, .item-title::before {
  background-color: #141e55;
  border-radius: 20px;
  content: "";
  height: 14px;
  position: absolute;
  right: 24px;
  top: 21px;
  transition: all 0.2s ease-in-out 0s;
  width: 2px;
}
@media (min-width: 960px) {
  .item-title::after, .item-title::before {
    top: 24px;
  }
}
.item-title::after {
  transform: rotate(90deg);
}

.item-toggle {
  display: none;
}

.item-content {
  backface-visibility: hidden;
  max-height: 0;
  overflow: hidden;
  padding-bottom: 0;
  padding-top: 0;
  transform: translateZ(0);
  transition-duration: 0.2s;
  transition-property: max-height, padding-bottom, padding-top;
  transition-timing-function: ease-out;
}`;

// src/components/jb-accordion-item/jb-accordion-item.ts
var JbAccordionItem = class extends h {
  _sendTrackingClick() {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_interaction",
          event_version: "v2",
          component_name: "accordion-item",
          interaction_effect: "toggle",
          interaction_element: "Accordion",
          interaction_result: this._input.checked ? "close" : "open",
          interaction_text: this.headline,
          interaction_type: "click"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`
      <div class="item">
        <input
          type="checkbox"
          class="item-toggle"
          id="checkbox"
        />
        <div
          class="item-header"
          @click=${this._sendTrackingClick}
        >
          <label
            class="item-title"
            for="checkbox"
          >
            ${this.headline}
          </label>
        </div>
        <input
          type="checkbox"
          class="item-toggle"
          id="checkbox"
        />
        <div class="item-content"><slot></slot></div>
      </div>
    `;
  }
};
JbAccordionItem.styles = r(jb_accordion_item_default);
__decorateClass([
  n()
], JbAccordionItem.prototype, "headline", 2);
__decorateClass([
  e("input")
], JbAccordionItem.prototype, "_input", 2);
JbAccordionItem = __decorateClass([
  customElement("jb-accordion-item")
], JbAccordionItem);

export {
  JbAccordionItem
};
